/** A new dispatch: its header first; Start creates the draft. */
import { DISPATCH_KINDS } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { DispatchPage } from "@/features/sales-dispatch/components/dispatch-page";

export const Route = createFileRoute("/_app/dispatch/sales/$kind/new")({
  params: { parse: (p) => ({ kind: z.enum(DISPATCH_KINDS).parse(p.kind) }) },
  beforeLoad: () => {
    if (!useAuth.getState().can("document.create")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useParams();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <DispatchPage
      key={kind}
      kind={kind}
      dispatch={null}
      facilityId={selected?.id}
    />
  );
}
